import axios from 'axios';

type GetUserIdByEmailResponse = {
  users: {
    id: string;
    mlsNumbers: string;
  }[];
};

const getUserIdByEmail = async (userEmail: string) => {
  const {
    data: { users },
  } = await axios.get<GetUserIdByEmailResponse>(
    `/brokerbay_admin/user_id/email/${userEmail}`,
  );

  return users;
};

export default getUserIdByEmail;
